const zh = {
	certification: {
		verification: '实名信息',
		updateHistory: '变更记录',
		certificateRequired: '证件到期提醒',
		changeIdentites: '变更法人、股东、受益人',
		changePerson: '变更法人、股东、受益人',
		completeIdentityVerification: '完善实名信息',
		verificationTips: '根据相关监管机构要求及保障您的账户安全，PingPong需收集用户的真实身份信息并进行验证。',
		verificationTips2nd: 'PingPong承诺将对您提供的实名信息严格保密。',
		imgUploadTips: '上传图片要求：请确保 ',
		imgUploadTips2nd: '照片信息清晰可见，以提升审批时效',
		imgUploadTips3rd: '最大不超过10M，格式限定为JPG、JPEG、PNG、BMP。',
		imgExample: '查看图片示例',
		auditReport: '审核报告',
		writeCompany: '填写公司信息',
		writeLegal: '填写法人信息',
		writeDirector: '填写股东信息',
		writeDirector2: '填写董事信息',
		writeBeneficiary: '填写受益人信息',
		uploadDesc: '请确保照片信息清晰可见，以提升审批时效。'
	},
	photoTips: {
		correct: '正确规范：',
		error: '错误示例：',
		specification1: '四角必须完整展示',
		specification2: '亮度均匀不反光',
		specification3: '内容清晰可辩识度高',
		example1: '照片不完整',
		example2: '照片模糊不清',
		example3: '照片反光严重'
	},
	review: {
		messageTip: '您的实名信息审核中，请耐心等待',
		messageReSubmit: '您提交的实名认证因为资料缺失或者信息错误原因，导致审核失败，请重新提交。',
		approved: '您的实名信息已审核通过',
		uneligible: '很遗憾，您目前不符合条件。'
	},
	add: {
		applicantsIdentity: '法人信息 Applicant’s Identity',
		informationofApplicant: '请填写企业法人信息',
		addApplicantIdentity: '添加法人',
		shareholderIdentity: '股东信息 Director’s Identity',
		shareholderIdentity2: '董事信息 Director’s Identity',
		informationofshareholder: '请填写企业所有股东信息',
		informationofshareholder2: '请填写企业所有董事信息',
		addashareholder: '添加股东',
		addashareholder2: '添加董事',
		BeneficiaryIdentity: '受益人信息 Beneficiary’s Identity',
		informationofBeneficiary: '请填写持股>=25%的自然人股东信息',
		informationofBeneficiary2: '请填写持股>=25%的自然人董事信息',
		addabeneficiary: '添加受益人',
		goBack: '返回上一步',
		saveAndNext: '保存并进入下一步',
		submitwebsite: '提交并添加网站',
		submitVerification: '提交实名信息',
		save: '暂存上述信息',
		deleted: '删除成功',
		deleteFailed: '删除失败',
		tryAgain: '请重试',
		pic: '添加图片',
		uploadFile: '上传文件',
		reupload: '重新上传',
		uploadSuccess: '文件上传成功',
		notice: '注意',
		uploadFileNotice: '上传文件大小不能超过 ',
		imgLimited: '图片应为JPG、JPEG、PNG、BMP格式',
		pictureFormatError: '图片格式错误',
		picUploadSuccess: '图片上传成功',
		uploadMethods: '请选择上传方式',
		PleaseUploadInformation: '请上传资料',
		uploadFailed: '图片上传失败，请重新上传',
		uploadLimited: '图片应为JPG、JPEG、PNG、BMP格式',
		uploadagain: '请删除原图片重新上传',
		uploadPic1st: '只能上传',
		uploadPic2nd: '张图片哦',
		reupload2: '图片上传失败',
		choose: '选取'
	},
	company: {
		businessInformation: '公司信息 Business Information',
		businessLocation: '公司注册所在国家或者地区',
		nationality: '公司注册所在国家或者地区',
		select: '请选择',
		china: '中国大陆',
		hongkong: '中国香港',
		europe: '欧洲',
		america: '美洲',
		africa: '非洲',
		oceania: '大洋洲',
		asia: '亚洲',
		usa: '美国',
		companyNameChinese: '公司中文名称',
		companyNameEnglish: '公司英文名称',
		businessCityChinese: '城市',
		businessAddressChinese: '详细中文地址',
		businessCityEnglish: '城市（英文）',
		businessAddressEnglish: '详细地址（英文）',
		postCode: '邮编',
		businessType: '公司类型',
		soleProprietorship: '个人独资',
		companyLimited: '有限责任公司',
		jointVentureCompany: '合营公司',
		listedCompany: '上市公司',
		corporationOrganization: '公司、法人、团体',
		others: '其他',
		businessIdentityNumber: '营业执照号码',
		businessEstablishedDate: '营业执照生效日期',
		businessExpirationDate: '营业执照失效日期',
		governmentIssuedBusinessCertification: '营业执照照片',
		HKBusinessRegistrationOrdinance: '商业登记证书',
		businessRegistrationOrdinanceExpirationDate: '公司注册时间',
		hkBusinessRegistrationOrdinanceEffectDate: '商业登记证书生效日期',
	    hkBusinessRegistrationOrdinanceExpirationDate: '商业登记证书失效日期',

		selectTheDate: '选择日期',
		longTermEffective: '长期有效',
		certificateofIncorporation: '公司注册证书照片',
		hkCertificateofIncorporation: '公司注册证书',
		certificateofIncorporationNumber: '公司注册证书号码',
		hkCertificateofIncorporationNumber: '公司注册书号码',

		certificateofIncorporationEstablishedDate: '公司注册证书生效日期',
		certificateofIncorporationExpireDate: '公司注册证书失效日期',
		bankAccountInformation: '银行开户许可证或基本存款账户信息',
		bankAccountInformationTip: '请上传银行开户许可证或基本存款账户信息',
		picture: '图片',
		EXCEL: 'EXCEL文件',
		pdf: 'PDF 文件',
		officePhotos: '办公室照片',
		tokenofficePhotos: '请上传2～5张办公室环境、前台相关照片。需要展示公司名称或公司LOGO。',
		submitSelect: '以下两项请至少选择一项提交',
		billOrcontract: '公司办公室租赁合同 或 公司水电费账单（请提供带办公地址的水电费账单）',

		companyCharter: '公司章程（如需申请虚拟账户请填写）',
		companyCharterDesc: '如实名认证审核通过后需添加此材料，请至【提现账户】申请虚拟账户',
		'united-states': '美国'

	},
	example: {
		checkImageExamples: '图片示例',
		uploadTip: '上传图片要求：请确保上传资料图片文字清晰可见，最大不超过10M，格式限定为JPG、JPEG、PNG、BMP、PDF。',
		IDCardExample: '身份证示例',
		businessLicense: '企业执照',
		frontofIDCard: '身份证人像面照片',
		backofIDCard: '身份证徽章面照片',
		businessIdentity: '营业执照',
		hongkongId: '香港身份证',
		additionalInformation: '附加信息',
		provideInfo: '您可以提供贵司相关的额外优质材料，以便我们更了解贵司。如董事地址证明、美国国税局EIN证明或个人SSN等信息。',
		uploadMethod: '上传方式',
		passport: '护照首页',
		travelPermit: '大陆往来通行证照片',
		otherPhoto: '其他照片'
	},
	rules: {
		bankAccountInfo: '请上传银行开户许可证或基本存款账户信息',
		proofFlow: '请上传流水证明',
		registeredCompany: '请选择公司注册所在国家或者地区',
		companyChineseName: '请输入公司中文名称',
		companyEnglishName: '请输入公司英文名称',
		chooseCity: '请选择城市',
		companyChineseAddress: '请输入公司中文地址',
		companyEnglishAddress: '请输入公司英文地址',
		companyEnglishCity: '请输入英文城市',
		companyEnglishAddressValid: '请输入有效信息',
		postCode: '请输入邮编',
		postCodeValid: '只允许输入英文和数字',
		businessIdentityNumber: '请输入营业执照号码',
		certificateEstablishedDate: '请选择公司注册时间',
		bussinessEstablishedDate: '请选择营业执照生效日期',
		companyExpiredDate: '请选择公司注册证书失效日期',
		governmentBussinessCertification: '请上传营业执照照片',
		HKgovernmentBussinessCertification: '请上传商业登记证照片',
		governmentBussinessCertification2: '请上传公司注册证书照片',
		applicationForm: '请上传商户申请表',
		websiteCertificate: '请上传网站域名注册证明',
		billOrlease: '请上传公司办公室租赁合同或公司水电费账单',
		addedUser: '使用已添加人物信息',
		IDType: '证件类型',
		IDCardNumber: '证件号码',
		IDNumber: '证件号码',
		IDIssueDate: '证件生效日期',
		IDExpirationDate: '证件失效日期',
		legal: '法人',
		director: '股东',
		director2: '董事姓名',
		beneficial: '受益人',
		legalIDCardUpdate: '法人身份证件更新',
		directorIDCardUpdate: '股东身份证件更新',
		directorIDCardUpdate2: '董事身份证件更新',
		beneficialIDCardUpdate: '受益人身份证件更新',
		legalInfoUpdate: '法人信息更新',
		directorInfoUpdate: '股东信息更新',
		directorInfoUpdate2: '董事信息更新',
		beneficialInfoUpdate: '受益人信息更新',
		companyUpdate: '公司证件更新',
		legalChange: '变更法人',
		directorChange: '变更股东',
		beneficialChange: '变更受益人',
		fullName: '姓名',
		fullNameEN: '姓名 英文',
		firstNameEN: '名 英文',
		lastNameEN: '姓 英文',

		fullShareholderName: '股东姓名',
		fullShareholderName2: '董事姓名',

		fullShareholderNameEN: '股东姓名 英文',
		firstShareholderNameEN: '股东名 英文',
		lastShareholderNameEN: '股东姓 英文',

		fullShareholderNameEN2: '董事姓名 英文',
		firstShareholderNameEN2: '董事名 英文',
		lastShareholderNameEN2: '董事姓 英文',

		fullBeneficiaryName: '受益人姓名',
		fullBeneficiaryNameEN: '受益人姓名 英文',
		firstBeneficiaryNameEN: '受益人名 英文',
		lastBeneficiaryNameEN: '受益人姓 英文',

		halfName: '姓名',
		sameInId: '与证件中的拼音一致',
		phoneNumber: '联系电话',
		emailAddress: '邮箱',
		DOB: '出生日期',
		nationality: '居住地区',
		addressChinese: '中文居住地址',
		ConsistentWithid: '请与证件上的地址保持一致',
		addressEnglish: '英文居住地址',
		save: '保存',
		submit: '保存',
		cancel: '取消',

		InputIDExpirationDate: '请选择证件失效日期',
		saveSuccess: '保存成功',
		saveFailed: '保存失败',
		reSave: '请重新保存',
		selectIDType: '请选择证件类型',
		uploadIDpic: '请上传证件照片',
		uploadIDbackPic: '请上传身份证反面照片',
		inputIDNumber: '请填写证件号码',
		inputIDExpireDate: '请选择证件生效日期',
		pleaseEnter: '请输入',
		realNameCn: '请输入中文名字',
		realNameEn: '请输入英文名字',
		realNameEnRule: '请输入英文字符，不允许输入空格',
		enterPhoneNumber: '请输入联系电话',
		enterEmail: '请输入邮箱',
		selectDOB: '请选择出生日期',
		errorDOB: '年龄不能不能小于18周岁',
		selectNation: '请选择居住国家',
		enterAddressChinese: '请输入中文居住地址',
		enterAddressEnglish: '请输入英文居住地址',
		selectBussinessType: '请选择公司类型',
		chinaId: '大陆身份证',
		hongkongId: '香港身份证',
		passport: '护照',
		permit: '大陆往来通行证',
		others: '其他',
		companyCharter: '公司章程',
		otherstuff: '其他信息上传',
		companyCharterWarn: '请上传公司章程',
		companyType: '请选择公司类型',
		selectState: '请选择州',
		inputCity: '请输入城市名',
		selectContinent: '请选择大洲',
		error1: '生效日期不能大于失效日期',
		error2: '失效日期不能小于生效日期',
		error3: '未进行任何操作不能提交'
	},
	approveInfo: {
		menuList: ['公司信息', '法人信息', '股东信息', '董事信息', '受益人信息', '变更记录'],
		edit: '编辑{name}',
		add: '添加{name}',
		save: '保存并提交审核',
		saveWarning: '未进行任何操作不能提交',
		saveError: '至少存在一个{name}',
		cancel: '取消修改',
		legal: {
			desc: '当前的法人为'
		},
		director: {
			desc: '当前的股东为',
			desc2: '当前的董事为'
		},
		beneficial: {
			desc: '当前受益人为'
		}
	},
	update: {
		time: '提交时间',
		type: '变更类型',
		status: '状态',
		operator: '操作人',
		modify: '修改',
		improved: '待完善内容',
		go: '前往',
		forDetail: '查看证件审核情况',
		edit: '填写'
	},
	status: {
		pending: '审核中',
		modify: '待修改',
		passed: '审核通过'
	},
	success: {
		title: '您的实名信息已提交，请继续添加网站。',
		tips: ['审核将在销售初审后5至7个工作日完成。可联系您的销售查询审核进度。', ''],
		btn: '开始添加网站'
	},
	changePerson: {
		toHistory: '提交后若需查看审核进度，请至 <a href="/aq/certification?type=updateHistory" style="color:#1fa0e8;display:inline">【变更记录】</a> 中查看',
		changeTo: '变更对象',
		addLegalTip: '提交且审核通过后，该法人将自动替换原法人',
		addLegal: '添加新的法人',
		existDirector: '现有股东（可删除，不可编辑）',
		addDirectorTip: '新增股东',
		addDirector: '添加股东',
		existBeneficial: '现有受益人（可删除，不可编辑）',
		addBeneficialTip: '新增受益人，请填写持股>=25%的自然人股东信息',
		addBeneficial: '添加受益人'
	},
	uploadError: '请上传{name}相关文件'
}

export default zh
